import template from './notification.html';
import controller from './notification.controller';
import './notification.scss';

let notificationComponent = {
  bindings: {},
  template,
  controller
};

export default notificationComponent;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification.component.js